import { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);

    const showToast = (message, type = "success") => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 5000); 
    };

    return (
        <ToastContext.Provider value={showToast}>
            {children}
            {toast && (
                <div className={`toast toast-${toast.type} toast-show`}>
                    {toast.message}
                </div>
            )}
        </ToastContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useToast = () => useContext(ToastContext);
